// @flow
import type { PrismicLinkType } from '~schema';

export default function getLinkedAuthorType(link: ?PrismicLinkType) {
  const document = link && link.document;
  return document && document.__typename === 'PrismicAuthor'
    ? document
    : undefined;
}
